import { NavLink } from "react-router-dom";
import { useState } from "react";
import urlConst from "../urlConsts";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import "./Sidebar.css";
import { useEffect } from "react";
import Logo from "../logo/Logo.svg";
import { Link } from "react-router-dom";
const Sidebar = () => {
  const location = useLocation();
  const organization = useSelector(
    (state) => state.organizationDetails.organization
  );
  const {
    userLogin: {
      userInfo: { data },
    },
  } = useSelector((state) => state);

  // Function to check active path
  function useActivePath(paths) {
    return paths.some((path) => location.pathname.includes(path));
  }

  const isActiveApps = useActivePath(["/apps", "/app"]);

  const isActiveOrganizations = useActivePath([
    "/organizations",
    "/organization",
  ]);
  const organizationuserRole = organization?.user_role;

  // Sidebar visibility state
  const [sidebarVisible, setSidebarVisible] = useState(
    localStorage.getItem("sidebarVisible") === "true"
  );
  
  // Settings dropdown state - separate from sidebar visibility
  const [settingsDropdownVisible, setSettingsDropdownVisible] = useState(false);

  const closeSidebar = () => {
    setSidebarVisible(false);
    setSettingsDropdownVisible(false); // Also close settings dropdown when sidebar closes
    localStorage.setItem("sidebarVisible", "false");
    window.dispatchEvent(new Event("storage"));
  };

  // Toggle settings dropdown
  const toggleSettingsDropdown = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
    setSettingsDropdownVisible(!settingsDropdownVisible);
  };

  // Close sidebar on clicking outside or scrolling
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Check if click is inside dropdown or the organization select box
      if (
        event.target.closest(".MuiSelect-root") || // MUI Select box
        event.target.closest(".MuiPaper-root") || // Dropdown items
        event.target.closest("#organization-select") || // Backup for your select
        event.target.closest(".user-dropdown") || // User dropdown
        event.target.closest(".navbar-toggler") // Toggle button
      ) {
        return; // Don't close sidebar if clicking inside these
      }
  
      if (sidebarVisible) {
        closeSidebar();
      }
    };
  
    const handleScroll = () => {
      if (sidebarVisible) {
        closeSidebar();
      }
    };
  
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("scroll", handleScroll);
  
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("scroll", handleScroll);
    };
  }, [sidebarVisible]);
  

  // Sync sidebar state across tabs
  useEffect(() => {
    const handleStorageChange = () => {
      const isVisible = localStorage.getItem("sidebarVisible") === "true";
      setSidebarVisible(isVisible);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <>
      <nav
        className={`sidebar ${sidebarVisible ? "sidebar-visible" : ""}`}
        id="sidebar"
      >
        <div className="d-none logo">
          <Link
            className="navbar-brand brand-logo"
            style={{ textAlign: "center" }}
            to="/apps"
          >
            <img src={Logo} alt="logo" />
          </Link>
        </div>
        <ul className="nav">
          {urlConst === "test" && (
            <li className="nav-item" onClick={closeSidebar}>
              <NavLink className="nav-link" to="/dashboard">
                <i className="fa fa-home menu-icon" aria-hidden="true"></i>
                <span className="menu-title">Dashboard</span>
              </NavLink>
            </li>
          )}

          {data.role !== "Super_Admin" &&
          organizationuserRole === "Admin" &&
          (location.pathname !== "/organization/create" ||
            location.pathname !== "/Auth/create" ||
            location.pathname !== "/user-password") ? (
            <>
              <li className="nav-item" onClick={closeSidebar}>
                <NavLink className="nav-link" to="/apps">
                  <i className="bi bi-box-seam menu-icon"></i>
                  <span className="menu-title">Apps</span>
                </NavLink>
              </li>

              <li className="nav-item" onClick={closeSidebar}>
                <NavLink className="nav-link" to="/users">
                  <i className="bi bi-person-add menu-icon"></i>
                  <span className="menu-title">Users</span>
                </NavLink>
              </li>

              <li className="nav-item dropdown-settings">
                <div
                  className="nav-link"
                  onClick={toggleSettingsDropdown}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.querySelector(".arrow-icon").style.color =
                      "#e0a625")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.querySelector(".arrow-icon").style.color =
                      "inherit")
                  }
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <i className="bi bi-gear menu-icon"></i>
                    <span className="menu-title">Settings</span>
                  </div>
                  <i
                    className={`bi ${
                      settingsDropdownVisible ? "bi-chevron-up" : "bi-chevron-down"
                    } arrow-icon`}
                    style={{ transition: "color 0.3s ease" }}
                  ></i>
                </div>
                {settingsDropdownVisible || (
                 <ul
                   className="nav-dropdown"
                   style={{
                     maxHeight: "200px",
                     overflow: "hidden",
                     transition: "max-height 0.3s ease-in-out",
                     paddingLeft: "20px",
                   }}
                 >
                   <li
                     className="nav-item"
                     onClick={closeSidebar}
                     style={{
                       display: "flex",
                       alignItems: "center",
                       gap: "8px",
                       padding: "8px 0",
                     }}
                   >
                     <i
                       className="bi bi-shield-lock-fill"
                       style={{ fontSize: "1.2rem", color: "#e0a625" }}
                     ></i>
                     <NavLink className="nav-link" to="/Auth/create">
                       <span className="menu-title">2FA</span>
                     </NavLink>
                   </li>
                   <li
                     className="nav-item"
                     onClick={closeSidebar}
                     style={{
                       display: "flex",
                       alignItems: "center",
                       gap: "8px",
                       padding: "8px 0",
                     }}
                   >
                     <i
                       className="bi bi-key-fill"
                       style={{ fontSize: "1.2rem", color: "#e0a625" }}
                     ></i>
                     <NavLink className="nav-link" to="/user-password">
                       <span className="menu-title">Password</span>
                     </NavLink>
                   </li>
                 </ul>
                )}
              </li>
            </>
          ) : data.role !== "Super_Admin" &&
            organizationuserRole !== "Admin" &&
            location.pathname !== "/organization/create" &&
            location.pathname !== "/Auth/create" ? (
            <li
              className={`nav-item ${isActiveApps ? "active" : ""}`}
              onClick={closeSidebar}
            >
              <NavLink
                className={`nav-link ${isActiveApps ? "active" : ""}`}
                to="/apps"
              >
                <i className="bi bi-box-seam menu-icon"></i>
                <span className="menu-title">Apps</span>
              </NavLink>
            </li>
          ) : null}

          {location.pathname === "/organization/create" &&
            location.pathname !== "/Auth/create" && (
              <li
                className={`nav-item ${isActiveApps ? "active" : ""}`}
                onClick={closeSidebar}
              >
                <NavLink
                  className={`nav-link ${isActiveApps ? "active" : ""}`}
                  to="#"
                >
                  <i className="bi bi-box-seam menu-icon"></i>
                  <span className="menu-title">Organization</span>
                </NavLink>
              </li>
            )}

          {urlConst === "test" && (
            <li className="nav-item" onClick={closeSidebar}>
              <NavLink className="nav-link" to="/products">
                <i className="fa fa-cube menu-icon" />
                <span className="menu-title">Products</span>
              </NavLink>
            </li>
          )}

          {data.role === "Super_Admin" && (
            <li
              className={`nav-item ${isActiveOrganizations ? "active" : ""}`}
              onClick={closeSidebar}
            >
              <NavLink
                className={`nav-link ${isActiveOrganizations ? "active" : ""}`}
                to="/organizations"
              >
                <i className="bi bi-person-add menu-icon"></i>
                <span className="menu-title">Organizations</span>
              </NavLink>
            </li>
          )}
        </ul>
      </nav>
    </>
  );
};

export default Sidebar;